(function($){
    WebFont.load({
    google: {
      families: ['Oswald']
    }
  });

    
	/* Get accurate Viewport sizing (no jQuery) */
    var viewportwidth;
    var viewportheight;

    function getWindowSize(){
        if (typeof window.innerWidth != 'undefined'){
            viewportwidth = window.innerWidth,
            viewportheight = window.innerHeight
        }else if (typeof document.documentElement != 'undefined' && typeof document.documentElement.clientWidth != 'undefined' && document.documentElement.clientWidth != 0){
            viewportwidth = document.documentElement.clientWidth,
            viewportheight = document.documentElement.clientHeight
        }else{
            viewportwidth = document.getElementsByTagName('body')[0].clientWidth,
            viewportheight = document.getElementsByTagName('body')[0].clientHeight
        }
    }
    
    $('.lazy').Lazy();
    
    function initSlider() {
        $('.slider').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 6000,
            dots: false,
            arrows: true,
            infinite: true,
            fade: true,
//            autoplaySpeed: 5000,
        });
    }
    
    function stickyNav(){
        var scrollTop = $(window).scrollTop(),
            size = $('.site-topnav').outerHeight(true),
            headerSub = '';
        
		if (scrollTop > size) {

			$('.site-topnav').addClass('sticky');
            $('#page').css('margin-top',size);

		} else {

			$('.site-topnav').removeClass('sticky');
            $('#page').css('margin-top','');
		}

	};

	/* Document Ready */
	$(document).ready(function() {
		getWindowSize();
        
        AOS.init({
            duration: 400,
            once: true,
        });
        
        initSlider();
        stickyNav();
        
        $('.popup-modal').magnificPopup({
            type: 'inline',
            preloader: false,
//            modal: true
        });
        $(document).on('click', '.popup-modal-dismiss', function (e) {
            e.preventDefault();
            $.magnificPopup.close();
        });
        
        //Accordion
        $('.accordion').find('.accordion--title').on('click', function(e) {
            e.preventDefault();
            $(this).toggleClass('active');
            $(this).next().slideToggle('fast');
        });
        
        
        //Sidr
        $('#mobile-trigger').sidr({
            side: 'right',
            name: 'sidr',
            displace: false,
            source : function() {
                var sidrHtml;
                
                sidrHtml = '<div id="mobile-menu">';
                
                sidrHtml += '<span class="sidr__close" aria-label="Close Menu"></span><div class="sidr__logo">' + $('.site-header .site-logo').html() + '</div>';
                
                sidrHtml += '<div class="sidr__inner">';
                
//                sidrHtml += '<div class="sidr__mainnav">' + $('.main-navigation--left').html() + $('.main-navigation--right').html() + '</div>';
                sidrHtml += '<div class="sidr__mainnav">' + $('.main-navigation--left').html() + '</div>';
                
                sidrHtml += '</div></div>';
                    
                return sidrHtml;
            },
            onOpen: function() {
                //alert('test');
                $( 'body' ).prepend( '<div class="sidr-overlay"></div>' );
            },
            onOpenEnd: function(){
                $( 'body' ).css({
                    "position": "fixed",
                    "left": "0",
                    "top": "0",
                    "width": "100%"
                });
            },
            onClose: function(){
                $( '.sidr-overlay' ).remove();
            },
            onCloseEnd: function(){
                $( 'body' ).css({
                    "position": "relative",
                    "left": "auto",
                    "top": "auto",
                    "width": "100%"
                });
            }
        });
        $('.menu-item-has-children .arrow').click(function(e) {
            e.preventDefault();
            $(this).toggleClass('active').next().slideToggle();
        });
        $('.sidr__close').click(function() {
            $.sidr('close','sidr');
        });
        
	});
    $(window).scroll(function(){
        stickyNav();
    });
	$(window).on("resize", function() {
		getWindowSize();
	});

})(jQuery);